import React, { Component } from "react";
import { withRouter} from "react-router-dom";
import api from "../core/api";
import { Form } from 'semantic-ui-react';
import  Logo  from "./logo";
import trocaSenhaImg from "../img/troca-senha.png";
import imgAtivo from "../img/ativo.png";
import imgInativo from "../img/inativo.png";
//import api from "../core/api";
import { logout, getUserName, getAuxCtl, decryptPass } from "../core/auth";
import { isUndefined } from "util";
import formatError from "../js/formatError"

class Troca extends Component {
  constructor(props){
    super(props);
    this.state = {
      password: "",
      reppassword: "",
      error: isUndefined(this.props.history.location.state) || isUndefined(this.props.history.location.state.passo)?"Você deve passar por todo o fluxo da troca de senha.":"",
      passo: isUndefined(this.props.history.location.state)?false:!isUndefined(this.props.history.location.state.passo),
      validPass:[],
      todosValidos:false,
    };
    //this._validarPass("");
  }
  
  _validarPass (pass, rep) {
    /*
    - Deve conter entre 8 e 16 caracteres;
    - Deve ter pelo menos 2 números;
    - Evitar sequências de caracteres;
    - Não utilizar caracteres maiúsculos, especiais e acentuados;
    - Não pode iniciar por número;
    - Não utilizar as últimas 5 senhas;
    */
   
    // debugger; 
    // this.preventDefault();
    // console.log("validando: [" + pass + "]" );
    // console.log("validando: [" + pass + "]" );
    let vetorValidacao = [];
    let re8_16 = new RegExp('(.){8,16}');
    if(pass.match(re8_16)) {
      vetorValidacao.push({descricao:"Deve conter entre 8 e 16 caracteres;", valido:true});
    } else {
      vetorValidacao.push({descricao:"Deve conter entre 8 e 16 caracteres;", valido:false});
    }
    let re2nr = new RegExp('((.)*([0-9])(.)*([0-9])(.)*)');
    if(pass.match(re2nr)) {
      vetorValidacao.push({descricao:"Deve ter pelo menos 2 números;", valido:true});
    } else {
      vetorValidacao.push({descricao:"Deve ter pelo menos 2 números;", valido:false});
    }
    // let reRepCaracter1 = new RegExp("^([0-9a-z])(\\1){2}");
    let reRepCaracter2 = new RegExp('(111|222|333|444|555|666|777|888|999|000|123|234|345|456|567|678|789|890|aaa|bbb|ccc|ddd|eee|fff|ggg|hhh|iii|jjj|kkk|lll|mmm|nnn|ooo|ppp|qqq|rrr|sss|ttt|uuu|vvv|uuu|vvv|www|xxx|yyy|zzz)+');
    if(pass.match(reRepCaracter2)) {
      vetorValidacao.push({descricao:"Não deve conter sequências de caracteres;", valido:false});
    } else {
      vetorValidacao.push({descricao:"Não deve conter sequências de caracteres;", valido:true});
    }
    let reCarEspeciais = new RegExp('[^a-z0-9]+');
    if(!pass.match(reCarEspeciais)) {
      vetorValidacao.push({descricao:"Não deve conter caracteres maiúsculos, especiais e acentuados;",valido:true});
    } else {
      vetorValidacao.push({descricao:"Não deve conter caracteres maiúsculos, especiais e acentuados;",valido:false});
    }
    let reInitNr = new RegExp('^([a-z]{1})(.)*');
    if(pass.match(reInitNr)) {
      vetorValidacao.push({descricao:"Não pode iniciar por número;",valido:true});
    } else {
      vetorValidacao.push({descricao:"Não pode iniciar por número;",valido:false});
    }
    if(pass === rep) {
      vetorValidacao.push({descricao:"A senha e sua repetição devem ser iguais.",valido:true});
    } else {
      vetorValidacao.push({descricao:"A senha e sua repetição devem ser iguais.",valido:false});
    }
    let todosValidos = true;
    vetorValidacao.forEach(element => {
      todosValidos = todosValidos && element.valido;
    });
    this.setState({validPass:vetorValidacao, todosValidos:todosValidos});
  }

  handleRepticao = async e => {
    this.setState({ reppassword: e.target.value });
    this._validarPass(document.getElementById("pass").value, e.target.value);
  }

  handleOnClick = async e => {
    e.preventDefault();
    
    this.setState({ password: e.target.value });
    // console.log("this.state.password:" + this.state.password);
    // console.log(e);

    this._validarPass(e.target.value, document.getElementById("reppassword").value);
  }

  handleCancelar = async e => {
    e.preventDefault();
    if(window.confirm("Atenção: Tem certeza que deseja cancelar a troca de sua senha?")) {
      logout();
      this.props.history.push("/");
    }
  }

  handleTroca = async e => {
    e.preventDefault();
    
    const { password, reppassword } = this.state;
    if ((!password || !reppassword) || (password !== reppassword)) {
      this.setState({ error: "A nova senha e a sua repetição não conferem. Informe-as novamente." });
    } else {
      try {
        // Trocar a senha do usuário
        let oldpassword = decryptPass(getAuxCtl(), getUserName());
        let response = await api.post("/troca", { password, reppassword, oldpassword } );
        //console.log(response.data);
        //debugger;
        this.props.history.push("/sucesso", response.data);
      } catch (err) {
        formatError(err.response, this);
      }
    }
  };

  render() {
    if(!this.state.passo) {
      this.props.history.push("/");
    }
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <h5 className="card-title text-center margin-top">
              <img src={trocaSenhaImg} className="img-responsive troca-senha" alt="Confirmação de Dados" />
            </h5>
            <Form action="/app" onSubmit={this.handleTroca} autoComplete="off">
              <input 
                id="userName" 
                type="text" 
                className="form-control margin-button-input bkg-verde" 
                placeholder="Usuário" 
                value={getUserName()}
                disabled={true}
                />
              <p>Sua senha é única, pessoal e intransferível para os sistemas, rede, internet e e-mail.</p>
              {this.state.error && <div className="msgError center">{this.state.error}</div>}
              <input 
                autoFocus={true}
                id="pass" 
                type="password"
                className="form-control bkg-verde" 
                placeholder="Nova senha"
                autoComplete="off"
                max="16"
                onChange={this.handleOnClick}
                required />
              <input 
                id="reppassword" 
                type="password" 
                autoComplete="off"
                className="form-control bkg-verde" 
                max="16"
                placeholder="Repita nova senha:" 
                onChange={this.handleRepticao}
                required />
              <button id="btnConfirmar" className="btn btn-primary btn-block margin-top-input text-uppercase" type="submit" disabled={!this.state.todosValidos}>Confirmar</button>
              <button id="btnCancelar" className="btn btn-secondary btn-block text-uppercase" type="reset" onClick={this.handleCancelar}>Cancelar</button>
              <div className="movimento margin-top-input">
                <h1>A senha</h1>
                {this.state.validPass.map((val, ind) => 
                  <h6 key={ind}><img src={val.valido?imgAtivo:imgInativo} className="img-responsive padding-right" alt={val.valido?"Valido":"Inválido"} title={val.valido?"Valido":"Inválido"} />{val.descricao}</h6>
                )}
                 <h6>* Não pode coincidir com as últimas 5 senhas utilizadas;</h6>
              </div>
              <Logo />
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Troca);
